__turbopack_context__.v({
  "newsletter": "newsletter-component-module-scss-module__rEKynq__newsletter",
  "newsletter__consent-text": "newsletter-component-module-scss-module__rEKynq__newsletter__consent-text",
  "newsletter__form": "newsletter-component-module-scss-module__rEKynq__newsletter__form",
  "newsletter__successMessage": "newsletter-component-module-scss-module__rEKynq__newsletter__successMessage",
});
